import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminService } from '../admin.service';
import { TableComponent } from 'src/app/shared/common-components/table/table.component';
import * as moment from 'moment';
import { vovSharedService } from 'src/app/shared/services/vov-shared.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-year',
  templateUrl: './year.component.html',
  styleUrls: ['./year.component.scss']
})
export class YearComponent implements OnInit {
  @ViewChild('formRef') formRef: TemplateRef<any>;
  @ViewChild('confirmRef') confirmRef: TemplateRef<any>;
  @ViewChild(TableComponent, { static: false }) tableComp: TableComponent;

  public formDialog: MatDialogRef<any> = null;
  public confirmDialog: MatDialogRef<any> = null;
  public tableData;
  public showSpinner: boolean = false;
  public columnNames = {
    year: 'Year',
    updatedAt: 'Date Added',
    actions: '',
  };
  selectedItem;
  yearForm: FormGroup;
  btndisabled: boolean = false;

  constructor(
    public dialog: MatDialog,
    private formBuilder: FormBuilder,
    private adminService: AdminService,
    private vovSharedService: vovSharedService,
    private snackBar: MatSnackBar,
  ) { }

  ngOnInit(): void {
    this.yearForm = this.formBuilder.group({
      // streetNumber: ['', Validators.required],
      year: ['', [Validators.required, Validators.minLength(4)]],
    });
    this.getYears();
  }

  getYears() {
    this.showSpinner = true;
    this.adminService.getYearCycle().subscribe(res => {
      console.log(res);
      this.showSpinner = false;
      if (res && res.yearsList && res.yearsList.length) {
        res.yearsList.sort((a, b) => (a.year) - (b.year));
        const UpdatedArr = res.yearsList.map((date: any) => date.updatedAt ? { ...date, updatedAt: moment(date.updatedAt).format("Do MMM YY") } : date)
        this.tableData = UpdatedArr;
      }
      this.tableRendering();
      console.log(this.tableData, 'dataa')
    })
  }

  openDialogForm() {
    this.btndisabled = false;

    console.log(this.selectedItem, 'submitt')
    this.formDialog = this.dialog.open(this.formRef, {
      width: '350px',
      data: 'data'
    });
    this.formDialog.afterClosed().subscribe(result => {
      this.selectedItem = '';
      this.yearForm.reset();
    })
  }


  onYearSubmit() {
    this.btndisabled = true;
    let currentyear = new Date().getFullYear();
    if (currentyear > this.yearForm.controls['year'].value) {
      console.log('yearr')
      this.snackBar.open('' + 'Please add valid Year.', '', {
        duration: 1500,
        horizontalPosition: 'right',
        panelClass: 'warning-snackbar'
      });
      this.formDialog.close();
      return true
    }
    this.adminService.createYearDetail(this.yearForm.value).subscribe((res) => {
      if (res.message == 'Already Exist') {
        this.snackBar.open('' + 'Year already exist.', '', {
          duration: 1500,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
        this.formDialog.close();
        this.yearForm.reset();
      } else {
        this.snackBar.open('' + 'Year added successfully.', '', {
          duration: 1500,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
        this.getYears();
        this.formDialog.close();
        this.yearForm.reset();
      }

    });
  }

  selectedItems(item) {
    this.selectedItem = item.data;
    if (item.action === 'edit') {
      this.yearForm.patchValue({
        year: item.data.year,
      });
      this.openDialogForm();

    } else {
      this.confirmDialog = this.dialog.open(this.confirmRef, {
        width: '350px',
        data: 'data'
      });
    }
  }


  confirmDelete() {
    this.deleteYear(this.selectedItem.id);
    this.confirmDialog.close();
    this.selectedItem = '';
    this.showSpinner = true;
  }

  onNoClick() {
    this.confirmDialog.close();
  }

  editYears(e) {
    e.preventDefault();
    let currentyear = new Date().getFullYear();
    console.log(currentyear, this.yearForm.controls['year'].value)
    if (currentyear > +this.yearForm.controls['year'].value) {
      this.snackBar.open('' + 'Please add valid Year.', '', {
        duration: 1500,
        horizontalPosition: 'right',
        panelClass: 'warning-snackbar'
      });
      this.formDialog.close();
      return true
    }
    this.showSpinner = true;
    this.adminService.updateYearDetail({ data: this.yearForm.value, id: this.selectedItem.id }).subscribe((res) => {
      if (res.message == 'Already Exist') {
        this.snackBar.open('' + 'Year already exist.', '', {
          duration: 1500,
          horizontalPosition: 'right',
          panelClass: 'warning-snackbar'
        });
        this.showSpinner = false;
        this.formDialog.close();
        this.yearForm.reset();
      } else {
        this.snackBar.open('' + 'Year updated successfully.', '', {
          duration: 1500,
          horizontalPosition: 'right',
          panelClass: 'success-snackbar'
        });
        this.showSpinner = false;
        this.getYears();
        this.formDialog.close();
        this.yearForm.reset();
        this.selectedItem = '';
        console.log(this.selectedItem, 'editt')
      }
    });
  }

  deleteYear(year) {
    this.adminService.deleteYearDetail(year).subscribe((res) => {
      this.snackBar.open('Success :' + res.year, '', {
        duration: 3000,
        horizontalPosition: 'right',
        panelClass: 'success-snackbar'
      });
      this.getYears();
      this.tableRendering();
    });
  }

  tableRendering() {
    if (this.tableComp != undefined) {
      this.tableComp.renderTable();
    }
  }


}
